import { render } from "./PopularWatchFund.vue?vue&type=template&id=683507d3"
import script from "./PopularWatchFund.vue?vue&type=script&lang=js"
export * from "./PopularWatchFund.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__